import React from "react";

const SnowflakeIcon = ({ className }) => (
  <svg
    className={className || "h-auto w-8"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Snowflake brand blue background circle */}
    <circle cx="12" cy="12" r="12" fill="#29B5E8" />
    {/* Snowflake logo mark — simplified snowflake shape in white */}
    <g fill="#FFFFFF">
      {/* Center vertical bar */}
      <rect x="11" y="3" width="2" height="18" rx="1" />
      {/* Center horizontal bar */}
      <rect x="3" y="11" width="18" height="2" rx="1" />
      {/* Diagonal top-left to bottom-right */}
      <rect
        x="11"
        y="11"
        width="2"
        height="10"
        rx="1"
        transform="rotate(45 12 12)"
      />
      {/* Diagonal top-right to bottom-left */}
      <rect
        x="11"
        y="11"
        width="2"
        height="10"
        rx="1"
        transform="rotate(-45 12 12)"
      />
      {/* Branch tips — top */}
      <rect x="9.5" y="4" width="1.5" height="3" rx="0.75" transform="rotate(-30 10.25 5.5)" />
      <rect x="13" y="4" width="1.5" height="3" rx="0.75" transform="rotate(30 13.75 5.5)" />
      {/* Branch tips — bottom */}
      <rect x="9.5" y="17" width="1.5" height="3" rx="0.75" transform="rotate(30 10.25 18.5)" />
      <rect x="13" y="17" width="1.5" height="3" rx="0.75" transform="rotate(-30 13.75 18.5)" />
      {/* Branch tips — left */}
      <rect x="4" y="9.5" width="3" height="1.5" rx="0.75" transform="rotate(30 5.5 10.25)" />
      <rect x="4" y="13" width="3" height="1.5" rx="0.75" transform="rotate(-30 5.5 13.75)" />
      {/* Branch tips — right */}
      <rect x="17" y="9.5" width="3" height="1.5" rx="0.75" transform="rotate(-30 18.5 10.25)" />
      <rect x="17" y="13" width="3" height="1.5" rx="0.75" transform="rotate(30 18.5 13.75)" />
    </g>
  </svg>
);

export default SnowflakeIcon;
